import React, { useState } from 'react';

interface ValidationErrorsProps {
  errors: string[];
  maxVisibleErrors?: number;
}

const ValidationErrors: React.FC<ValidationErrorsProps> = ({
  errors,
  maxVisibleErrors = 3,
}) => {
  const [showAll, setShowAll] = useState(false);
  
  if (!errors || errors.length === 0) return null;
  
  const displayErrors = showAll ? errors : errors.slice(0, maxVisibleErrors);
  const hasMoreErrors = errors.length > maxVisibleErrors;
  
  return (
    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative mb-4" role="alert">
      <div className="flex items-start">
        <div className="flex-shrink-0 pt-0.5">
          <svg className="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3 w-full">
          <h3 className="text-sm font-medium">กรุณาแก้ไขข้อผิดพลาดต่อไปนี้:</h3>
          <ul className="mt-1 list-disc list-inside text-sm">
            {displayErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
          {hasMoreErrors && !showAll && (
            <button 
              onClick={() => setShowAll(true)}
              className="mt-2 text-sm font-medium text-red-700 hover:text-red-800 flex items-center"
            >
              แสดงข้อผิดพลาดทั้งหมด ({errors.length})
              <svg className="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          )}
          {showAll && (
            <button 
              onClick={() => setShowAll(false)}
              className="mt-2 text-sm font-medium text-red-700 hover:text-red-800 flex items-center"
            >
              แสดงน้อยลง
              <svg className="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ValidationErrors;